import React from 'react';
import StepsLayout, {
  TypeLayout
} from 'screens/Applications&WorkOrders/StepsLayout';

interface CreateWorkOrderProps {
  // Add your props here
}

const CreateWorkOrder: React.FC<CreateWorkOrderProps> = () => {
  return <StepsLayout type={TypeLayout.WORK_ORDER} />;
};

export default CreateWorkOrder;
